// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"586515e6","952":"d0b3b7b7"}[chunkId] + ".chunk.js";
};